<!-- RefreshButton.vue:
  表の更新を行うボタン -->
<template lang="html">
  <button id="refreshButton" type="button" class="orangedBackground"
  title="表を更新します"
  @click="refreshTable"
  @mouseenter="hover = true"
  @mouseleave="hover = false"
  :style="getStyle"><i class="icon-refresh"></i></button>
</template>

<script>
import {
  SPINNER_SHOW,
  SPINNER_HIDE
} from '@/vuex/mutation_types'
import {
  mapActions,
  mapGetters
} from 'vuex'

export default {
  data () {
    return {
      hover: false
    }
  },
  methods: {
    ...mapActions([
      'getReservations'
    ]),
    refreshTable () {
      this.$store.commit(SPINNER_SHOW)
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated
      }).then(() => {
        this.$store.commit(SPINNER_HIDE)
      })
    }
  },
  computed: {
    ...mapGetters([
      'getCurDateFormated'
    ]),
    getStyle () {
      if (this.hover) {
        return { opacity: 1.0 }
      } else {
        return { opacity: 0.5 }
      }
    }
  }
}
</script>

<style lang="css" scoped>
#refreshButton {
  position: fixed;
  top: 50px;
  right: 30px;
  width: 40px;
  height: 40px;
  font-size: 16px;

  border-radius: 50%;
  border-style: none;
  box-shadow:5px 5px 1px 0px #555555;
  margin: auto;
  color: white;
  opacity: 0.5;
  z-index: 1002;
}
</style>



// WEBPACK FOOTER //
// RefreshButton.vue?322f41f6